import { Box } from "@mui/material"
import type { FC } from "react"
import { useAppSelector } from "../../app/hooks"
import { InAppMessageCard } from "./InAppMessageCard"
import { selectVisibleInAppMessages } from "./inAppMessagesSlice"
import { useInAppMessageClose } from "./useInAppMessageClose"

const SLOT_UI = {
  top: "UI-SL2W-282",
  "below-header": "UI-SL2W-283",
} as const

/**
 * In-flow banner slots. `top` spans the page width under the app bar (above the side menu);
 * `below-header` sits at the top of the content column. In `embedded` / `RxPro` the app bar is
 * hidden, so both render at the top of the frame.
 */
export const InAppBannerSlot: FC<{ slot: keyof typeof SLOT_UI }> = ({
  slot,
}) => {
  const visible = useAppSelector(selectVisibleInAppMessages)[slot]
  const { dismissHandler } = useInAppMessageClose()
  if (visible.length === 0) return null
  return (
    <Box data-ui={SLOT_UI[slot]} sx={{ flexShrink: 0 }}>
      {visible.map(({ message }) => (
        <InAppMessageCard
          key={message.id}
          message={message}
          onClose={dismissHandler(message)}
          square
        />
      ))}
    </Box>
  )
}
